import { lazy } from "react";
import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/config/seoHead";

const ElpriserHistorik = lazy(() => import("@/pages/elpriser/Historik"));

export const Route = createFileRoute("/elpriser/historik/")({
  head: () => seoHead("/elpriser/historik"),
  component: () => <ElpriserHistorik />,
});
